const modelName = 'Orderwise Activity Logs';
const modelNameSingular = 'Orderwise Activity Log';
const endpoint = '/get_ow_activity_log';

const setup = {
    title: modelName,
    singular: modelNameSingular,
    model: modelName.replace(/\s+/g, '-').toLowerCase(),
    canDelete: true,
    canAddNew: true,
    canSearch: true,
    endpoint,
    accessor: 'id',
};

export default setup;
